export default __webpack_public_path__ + "static/media/img-0102-china-premium-face.cd01e148.png";